// <countdown-timer data-target="2026-05-15T23:59:59">
// Renders HH/MM/SS into [data-unit="hours|minutes|seconds"] children, ticks each second.
class CountdownTimer extends HTMLElement {
  connectedCallback() {
    const target = this.dataset.target;
    if (!target) return;
    this.targetDate = new Date(target);
    if (Number.isNaN(this.targetDate.getTime())) return;
    this.hours = this.querySelector('[data-unit="hours"]');
    this.minutes = this.querySelector('[data-unit="minutes"]');
    this.seconds = this.querySelector('[data-unit="seconds"]');
    this.tick();
    this.interval = window.setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    if (this.interval) window.clearInterval(this.interval);
  }

  tick() {
    const diff = Math.max(0, this.targetDate.getTime() - Date.now());
    const totalSec = Math.floor(diff / 1000);
    const h = Math.floor(totalSec / 3600);
    const m = Math.floor((totalSec % 3600) / 60);
    const s = totalSec % 60;
    if (this.hours) this.hours.textContent = String(h).padStart(2, '0');
    if (this.minutes) this.minutes.textContent = String(m).padStart(2, '0');
    if (this.seconds) this.seconds.textContent = String(s).padStart(2, '0');
    if (diff === 0 && this.interval) window.clearInterval(this.interval);
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
